import { useSelector } from "react-redux";

export const useImpactReadOnly = () =>
  useSelector(({ management }) => management.isReadOnlyImpactView);

/** True when form controls should be disabled (read-only impact modal). */
export const useImpactFormDisabled = (
  disabled = false,
  allowInReadOnlyView = false
) => {
  const readOnlyImpactView = useImpactReadOnly();
  if (allowInReadOnlyView && readOnlyImpactView) {
    return Boolean(disabled);
  }
  return Boolean(disabled || readOnlyImpactView);
};

/** Merges table readOnly prop with read-only impact modal flag. */
export const useTableReadOnly = (readOnly = false) => {
  const readOnlyImpactView = useImpactReadOnly();
  return Boolean(readOnly || readOnlyImpactView);
};

/** Opens a section dialog directly when in read-only impact view. Returns true if handled. */
export const openImpactBoxIfReadOnly = (readOnly, openFn) => {
  if (readOnly) {
    openFn();
    return true;
  }
  return false;
};
